import './style.scss';
import i18n from './i18n';
import { turnOnMobileTable, turnOffMobileTable } from './mobile-table/index';
import { importSelect2, initSelect2 } from './utils';

const MEDIUM_SCREEN_SIZE = 971;

$(function initialize() {
  importSelect2().then(() => {
    initSelect2();
    const table = document.querySelector('.new-table--calculator');
    if (table) {
      table.classList.add('is-visible');
    }
    registerEventsListeners();

    if ($(window).width() <= MEDIUM_SCREEN_SIZE) {
      turnOnMobileTable();
    }
  });
});

function registerEventsListeners() {
  const table = $('.new-table');
  const $detailsTabAction = $('.luna-tab a', table);
  const $toogleDetialsBtn = $('.toggle-details', table);
  const $calculator = $('.new-table--wrapper.calculator');

  $(window).on('resize', onResize);
  $detailsTabAction.on('click', onDetailsTabClick);
  $toogleDetialsBtn.on('click', onToogleDetails);
  $calculator.on('complete', onCalculate);
}

function onDetailsTabClick(event) {
  const $table = $('.new-table');
  const $currentTab = $(event.currentTarget).parent();
  const $allDetailsTabPanel = $('.luna-tabpanel');
  const detailsTabContext = $currentTab.attr('aria-controls');
  const $detailsTabPanelsWithTargetContext = $allDetailsTabPanel.filter(
    `[aria-labelledby="${detailsTabContext}"]`
  );
  const $allDetailsTabs = $('.luna-tab', $table);

  $allDetailsTabs.attr('aria-selected', false);
  $allDetailsTabPanel.attr('aria-hidden', true);
  $detailsTabPanelsWithTargetContext.attr('aria-hidden', false);
  $currentTab.attr('aria-selected', true);
}

function onToogleDetails(event) {
  const $target = $(event.currentTarget);
  const $wrapper = $target.parent();
  const $details = $('.details', $wrapper);
  const $linkIcon = $('i', $target);
  const $linkText = $('span', $target);
  const setLinkCaption = (text) => `${text} ${i18n.DETAILS}`;

  event.preventDefault();
  $linkIcon.toggleClass('active');
  $details.toggle();

  const iconStatusText = $linkIcon.hasClass('active') ? i18n.HIDE : i18n.SHOW;

  $linkText.text(setLinkCaption(iconStatusText));
}

function onResize() {
  const currentScreenWidth = $(window).width();

  if (currentScreenWidth <= MEDIUM_SCREEN_SIZE) {
    turnOnMobileTable();
  } else {
    turnOffMobileTable();
  }
}

function onCalculate(event) {
  const $calculatorTransferRate = $(event.currentTarget).find('.calculator-imt-rate');
  const currencyFromValue = $('#currency-from-select-box').val();

  $calculatorTransferRate.attr('data-title', `1 ${currencyFromValue} =`);
}
